import * as React from 'react';

export interface Props {
  redirectAcreditation: () => void;
}

const InvestmentLimitMessageComponent: React.StatelessComponent<Props> = (props: Props) => (
      <div>
        <p>
          Como Inversor&nbsp;
          <span className="c-orange">
                  <strong>
                  "No Acreditado"
                  </strong>
                </span>
          &nbsp;No puedes invertir más de 3.000 € en esta oportunidad de inversión. ¿Quieres invertir más de 3.000
          € por operación?&nbsp;
          <strong>
            <a
              style={{cursor: 'pointer'}}
              onClick={props.redirectAcreditation}
            >
              Acredítate.
            </a>
          </strong>
        </p>
      </div>
);

export default InvestmentLimitMessageComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/partials/InvestmentLimitMessage.component.tsx